import HCPInbox from './HCPInbox';

const SystemInbox = () => <HCPInbox />;

export default SystemInbox;
